import { render, staticRenderFns } from "./MergeAccountsModal.vue?vue&type=template&id=168c11a6"
import script from "./MergeAccountsModal.vue?vue&type=script&lang=js"
export * from "./MergeAccountsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__coffee-script@_ithsyumg4b75nafq24rv3fneqy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports